<template>
  <div>
    <div class="marginCenter">
      <div class="marginBom18 marginTop30 categoryTitle2 flex-yCenter flex-sb">
        <div class="left flex">
          <span>参加诊断治疗技术</span>
        </div>
        <div class="right flex-yCenter">
          <img src="@/assets/images/index/fanhui.png" alt="" />
          <router-link
            tag="span"
            to="/process/index"
            class="backIndex fcolor_blue2 fsize16"
          >
            返回
          </router-link>
        </div>
      </div>
      <p class="tips">进修周期内可填写，超出进修周期只可查看</p>
      <div class="dept marginTop24 marginBom24">
        <span style="margin-right: 30px"
          >进修科室：{{ query.trainObj.deptName }}</span
        >
        <span
          >进修周期：{{ query.trainObj.beginDate }}~{{
            query.trainObj.endDate
          }}</span
        >
      </div>
      <div
        v-if="query.operationType == 1"
        class="flex-sb flex-yCenter marginBom24"
      >
        <el-button type="primary" plain icon="el-icon-plus" @click="add"
          >新增</el-button
        >
        <i class="el-icon-delete pointer" @click="remove"></i>
      </div>
      <el-table
        :data="form.diagnosisList"
        border
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="100">
        </el-table-column>
        <el-table-column type="index" label="序号" align="center" width="150">
        </el-table-column>
        <el-table-column prop="name" label="操作名称" align="center">
        </el-table-column>
        <el-table-column prop="num" label="次数" align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="登记时间"
          align="center"
        ></el-table-column>
      </el-table>
      <div ref="page">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <Model
      :showState="showState"
      @confirm="confirm"
      @cancel="cancel"
      title="新增"
    >
      <template #content>
        <el-form ref="form" :model="formData" :rules="rules" label-width="auto">
          <el-form-item label="操作名称：" prop="name">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="次数：" prop="num">
            <el-input v-model="formData.num"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </Model>
  </div>
</template>
<script>
import {
  trainProcessDetail,
  trainProcessDiagnosis,
  trainProcessDiagnosisRemove,
} from "@/utils/api";
export default {
  data() {
    return {
      loading: false,
      form: {
        diagnosisList: [],
      },
      rules: {
        name: [
          { required: true, message: "操作名称不能为空", trigger: "blur" },
        ],
        num: [{ required: true, message: "次数不能为空", trigger: "blur" }],
      },
      total: 1,
      showState: false,
      formData: {},
      query: {},
      selectList: [],
    };
  },
  created() {
    this.query = this.$route.query;
    this.query.trainObj = JSON.parse(this.query.trainObj);
    this.getList();
  },
  methods: {
    getList() {
      trainProcessDetail(this.query.trainObj.trainId).then((res) => {
        if (res.code == 200) {
          this.form = res.data;
        }
      });
    },
    handleSelectionChange(list) {
      this.selectList = list;
    },
    add() {
      this.showState = true;
    },
    confirm() {
      this.$refs.form.validate((vaild) => {
        if (vaild) {
          this.formData.trainId = this.form.trainId;
          let arr = JSON.parse(JSON.stringify([this.formData]))
          trainProcessDiagnosis(arr).then((res) => {
            if (res.code == 200) {
              this.$message.success("新增成功");
              this.cancel();
              this.getList();
            }
          });
        }
      });
    },
    cancel() {
      this.showState = false;
      this.formData = {};
      this.$refs.form.resetFields();
    },
    //
    remove() {
      let that = this;
      if (this.selectList.length != 0) {
        that
          .$confirm("确认删除", "", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
          .then((e) => {
            let removeList = [];
            this.selectList.forEach((item) => {
              this.form.diagnosisList.forEach((sonItem, index) => {
                if (item.diagnosisId == sonItem.diagnosisId) {
                  removeList.push(item.diagnosisId);
                }
              });
            });
            trainProcessDiagnosisRemove(removeList).then((res) => {
              if (res.code == 200) {
                that.getList();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            });
          });
      }else{
        that.$message.error('请先选中要删除的内容！')
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.backIndex:hover {
  cursor: pointer;
}
.tips {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
}
.dept {
  span {
    font-size: 22px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #333333;
  }
}

.el-button--primary.is-plain {
  width: 118px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  background: #fff;
  color: #2d53c8;
  border-color: #2d53c8;
}
.el-icon-delete {
  font-size: 24px;
}
</style>
